import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Icon from '@material-ui/core/Icon'
import PropTypes from 'prop-types'
import Colors from '~shared/assets/styles/colors'
import resolveFieldLinkHref from './resolveFieldLinkHref'

const styles = theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  link: {
    marginLeft: theme.spacing.unit,
    marginTop: -2,
    display: 'inline-flex',
    alignItems: 'center',
    padding: `1px ${theme.spacing.unit}px`,
    borderRadius: 999,
    border: `1px solid ${Colors['Aqua020']}`,
    backgroundColor: Colors['Aqua010'],
    color: Colors.TextBrand,
    fontSize: '0.85em',
    fontWeight: 600,
    lineHeight: 1.5,
    textDecoration: 'none',
    position: 'relative',
    zIndex: 1,
    '&:hover': {
      backgroundColor: Colors['Aqua020'],
      textDecoration: 'none',
    },
  },
  icon: {
    fontSize: 16,
    marginRight: 4,
  },
})

const stopPropagation = e => {
  e.stopPropagation()
}

const FieldLabelLink = ({ classes, label, linkTemplate, linkText = 'Link', value }) => {
  const linkHref = resolveFieldLinkHref(linkTemplate, value)

  if (!label || !linkHref) return label

  return (
    <span className={classes.root}>
      <span>{label}</span>
      <a
        className={classes.link}
        href={linkHref}
        target="_blank"
        rel="noopener noreferrer"
        onClick={stopPropagation}
        onMouseDown={stopPropagation}
      >
        <Icon className={classes.icon}>open_in_new</Icon>
        {linkText}
      </a>
    </span>
  )
}

FieldLabelLink.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.node,
  linkTemplate: PropTypes.string,
  linkText: PropTypes.string,
  value: PropTypes.any,
}

export default withStyles(styles)(FieldLabelLink)
